import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom'
import { Container, Row, Col, Form } from 'react-bootstrap';
import location from '../../assets/img/icons/location.svg'
import filter from '../../assets/img/people/filter.svg'
import search from '../../assets/img/icons/search.svg'
import axios from 'axios';
import Join from './plan/join';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Matches extends Component {
    constructor(props) {
        super(props);
        this.frndSearch = this.frndSearch.bind(this);

        this.state = {
            peopleDetails: [],limit:8,premiummodal: false,
        }

    }

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        localStorage.setItem('vmsl_page', '2');
        const apiUrl = localStorage.getItem('api_url');

        let data = new FormData();
        data.append('user_id',JSON.parse(localStorage.getItem('session_userid')));
        data.append('language', this.state.langKey);  
      
        axios({
              method: 'post',
              url: apiUrl+'webprofile',
              data: data, 
              config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => { 
            if(res.data.status !== false) {
                const user_details = res.data.result;
                this.setState({
                    user_details: user_details,
                });
            } else {
                this.setState({ loginpage: true });
            } 
        }).catch(error => {
            this.setState({ loginpage: true });
        }); 

        var profile = new FormData();
        profile.set('user_id',JSON.parse(localStorage.getItem('session_userid')));
        profile.set('limit', this.state.limit);
        profile.set('language', this.state.langKey); 
        axios({
            method: 'post',
            url: apiUrl+'webfriendslist',
            data: profile,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status === "true"){
                const peopleDetails = res.data.peoples;
                const tmp_limit = this.state.limit;
                this.setState({ peopleDetails,limit: this.state.limit + 8});
                if(tmp_limit  === peopleDetails.length){
                    this.setState({ loadmore: 'loadMor btn-common'});
                }
            }else{
                this.setState({ nosuperlike: true });
            }
        })
    }

    loadMore(){ 
        const apiUrl = localStorage.getItem('api_url');

        var profile = new FormData();
        profile.set('user_id',JSON.parse(localStorage.getItem('session_userid')));
        profile.set('limit', this.state.limit);
        profile.set('language', this.state.langKey); 
            axios({
                method: 'post',
                url: apiUrl+'webfriendslist',
                data: profile,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
                            })
        .then(res => {
            if(res.data.status === "true"){
                const peopleDetails = res.data.peoples;
                // console.log("frienst_list",res.data);
                const tmp_limit = this.state.limit;
                this.setState({ peopleDetails,limit: this.state.limit + 8})
                if(tmp_limit  === peopleDetails.length){
                    this.setState({ loadmore: 'loadMor btn-common'});
                }else{
                    this.setState({ loadmore: 'none'});   
                }
            }else{
                this.setState({ nosuperlike: true });
            }
        })
       
    }

    frndSearch(e){
        const apiUrl = localStorage.getItem('api_url');
        const tmp = e.target.value;
        this.setState({frnd_search:tmp});
        if(e.target.value != null){
            this.setState({limit:8});
            var message = new FormData();
            message.set('user_id',JSON.parse(localStorage.getItem('session_userid')));
            message.set('search_key', e.target.value);
            message.set('language', this.state.langKey); 
             axios({
                method: 'post',
                url: apiUrl+'webfriendslist',
                data: message,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => {
                if(res.data.status === "true"){
                    const peopleDetails = res.data.peoples;
                    const tmp_limit = this.state.limit;
                    this.setState({ peopleDetails,limit: this.state.limit + 8})
                    if(tmp_limit  === peopleDetails.length){
                        this.setState({ loadmore: 'loadMor btn-common'});
                    }else{
                        this.setState({ loadmore: 'none'});   
                    }
                    this.setState({ peopleDetails,clas1: '',clas2:'',clas3:'',clas4:'',clas5:'',txt1:'',txt2:'' });
                }else{
                    this.setState({ nosuperlike: true });
                }
            })
        }             
            
    } 

    handlePremiumOpenModal = () => {
        this.setState({ premiummodal: true });
    }

    handlePremiumCloseModal = () => {
        this.setState({ premiummodal: false });
    }

    render() {
        if (this.state.nosuperlike) {
            return <Redirect to="/nosuperlike" />;
        }
        if (this.state.loginpage) {
            return <Redirect to="/" />;
        }
        const { t } = this.props;

        return (
            <>
                <section className='common_layout'>
                    <div className='header_layout mobile_matches_headerlayout'>
                        <div className='header_img'>
                            {/* <img src={filter} alt="img" className='filter_img' /> */}
                        </div>
                        <div className='header_title center_position mobile_matches_header'>
                            <h4><Trans i18nKey="Matches">Matches</Trans></h4>
                        </div>
                        <div className=''>
                            <div className='matches_search'>
                                <img src={search} alt="img" />
                                <Form.Control
                                    onChange={this.frndSearch} value={this.state.frnd_search} placeholder={t("type a message...")}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='mt_1'>
                        <div>
                            <Container>
                                <Row className=''>
                                    {this.state.peopleDetails.map((peopleDetails) => (
                                        <Col md={4} sm={4}>
                                            <div className='visitors_card'>
                                                <Link to={`/matchesdetail/${peopleDetails.user_id}`}>
                                                    <div className='visitor_img'>
                                                        <img src={peopleDetails.user_image} alt="img" />
                                                    </div>
                                                    <div className='visitor_content'>
                                                        <h4>{peopleDetails.user_name}{peopleDetails.show_age !== 1 && `, ${peopleDetails.age}`}</h4>
                                                        <div className='visitor_content_subdiv'>
                                                            {peopleDetails.show_distance !== 1 && (
                                                                <>
                                                                    <img src={location} alt="img" />
                                                                    <p>{peopleDetails.location}</p>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </Container>
                        </div>
                    </div>
                </section>
                <Join
                    showModal={this.state.premiummodal}
                    handleClose={this.handlePremiumCloseModal}
                />
            </>
        );
    }
}

export default withTranslation("translations")(Matches);
